import { useEffect, useState } from 'react';
import TextField from '../TextField/TextField';
import Title from '../Title/Title';
import './tabs.css';
import { useAppSelector } from '../../../store/hooks';

interface TabsProps {
    sections: string[];
    selectedTab: string;
    onChangeTab: (selectedTab: string) => void;
    dotIndex?: number;
}

const Tabs: React.FC<TabsProps> = ({
    sections,
    selectedTab,
    onChangeTab,
    dotIndex = -1,
}) => {
    const auth = useAppSelector(state => state.auth);
    const [selection, setSelection] = useState(selectedTab);

    useEffect(() => {
        if (auth.wasUserFetched) {
            setSelection(sections[0]);
        }
    }, [auth.wasUserFetched]);

    function onChangeTabHandler(section: string) {
        setSelection(section);
        onChangeTab(section);
    }

    return (
        <div className="tabs">
            {sections.map((section, index) => (
                <div
                    key={section}
                    className="tab-section"
                    onClick={() => onChangeTabHandler(section)}
                >
                    <TextField
                        color={selection === section ? 'green' : 'black'}
                        weight="bold"
                    >
                        {section}
                    </TextField>
                    {dotIndex !== -1 && dotIndex === index && (
                        <div className="tab-dot" />
                    )}
                </div>
            ))}
        </div>
    );
};

export default Tabs;
